<template>
    <v-layout>
        <Loading :value="loading" ></Loading>
        <v-dialog
                v-model="dialogFormDetailProf"
                persistent
                max-width="100%">
            <v-card>
                <v-toolbar dark color="primary">
                    <v-toolbar-title>Ajouter des détails professionnels sur l'employé</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon dark @click="closeForm()">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text>
                    <el-form label-position="top" ref="formDynamiqueProf" id="form1" name="form1" :model="formDynamiqueProf" >
                        <el-card class="box-card">
                            <el-row justify="center" type="flex" :gutter="20" v-for="(formProf, ind) in formDynamiqueProf.formDetailProfs" :key="(formProf.ind)">
                               <v-layout wrap class="mt-3" @click="indiceForm = ind">
                                   <v-flex xs12>
                                       <div class="subheading">Ligne {{ind+1}} </div>
                                       <v-divider></v-divider>
                                       <el-row  :gutter="20">
                                           <el-col :span="3">

                                               <el-form-item label="Etablissement/Entreprise*">
                                                   <el-input placeholder="Etablissement"   aria-required="true" id="etablissement" name="etablissement" type="text"  v-model="formProf.etablissement"></el-input>
                                               </el-form-item>

                                           </el-col>

                                           <el-col :span="3">
                                               <el-form-item label="Faculté/Classe/Service*">
                                                   <el-input placeholder="Faculté"   type="text"  id="faculte" v-model="formProf.faculte"></el-input>
                                               </el-form-item>
                                           </el-col>

                                           <el-col :span="6">
                                               <el-form-item label="Période de formation/contrat*">
                                                   <el-date-picker    id="periode"
                                                           format="d-MM-yyyy" 
                                                           v-model="formProf.periode"
                                                           range-separator="à"
                                                           start-placeholder="Date de début"
                                                           end-placeholder="Date de fin"
                                                           type="daterange"
                                                   >
                                                   </el-date-picker>
                                               </el-form-item>
                                           </el-col>

                                           <el-col :span="3">
                                               <el-form-item label="Diplome/Poste*">
                                                   <el-input placeholder="Diplome obtenu ou poste occupé" aria-required="true"  id="diplome" type="text"  v-model="formProf.diplome"></el-input>
                                               </el-form-item>
                                           </el-col>

                                           <el-col :span="4">
                                               <el-form-item label="Date diplome/contrat*" >
                                                   <el-date-picker id="dateDiplome" required 
                                                           format="d-MM-yyyy"
                                                           v-model="formProf.dateDiplome"
                                                           placeholder="Date d'obtention du diplome ou de signature du contrat"
                                                           type="date"
                                                   >
                                                   </el-date-picker>
                                               </el-form-item>
                                           </el-col>

                                           <el-col :span="4">
                                               <div>
                                                   <el-form-item label="Type de contrat">
                                                       <el-select clearable v-model="formProf.typeCont" placeholder="Type de contrat">
                                                           <el-option v-for="(item,index) in listeTypeContrat" :key=index :label="item.libelle" :value="item.libelle"></el-option>
                                                       </el-select>
                                                   </el-form-item>
                                               </div>
                                           </el-col>

                                           <el-col :span="1">
                                               <div>
                                                   <el-form-item label="." >
                                                       <v-tooltip bottom>
                                                           <v-btn
                                                                   slot="activator"
                                                                   icon
                                                                   flat
                                                                   color="red"
                                                                   @click="removeProf(formProf)"
                                                           >
                                                               <v-icon>clear</v-icon>

                                                           </v-btn>
                                                           Supprimer
                                                       </v-tooltip>
                                                   </el-form-item>
                                               </div>
                                           </el-col>
                                       </el-row>
                                   </v-flex>

                                   <v-flex xs12>
                                       <el-row>
                                           <el-col :span="24">
                                               <el-upload class="upload-demo"
                                                          list-type="picture-card"
                                                          :name="'Ligne'+(ind+1)"
                                                          action=""
                                                          ref="uploadFichProf"
                                                          :auto-upload="false"
                                                          :on-change = "changeFile"
                                                          :multiple="true" >
                                                   <img height="142"  width="142" src="" class="lazy" alt="">
                                               </el-upload>
                                           </el-col>
                                       </el-row>
                                   </v-flex>
                               </v-layout>







                            </el-row>

                        </el-card>
                        <el-row justify="end" >
                            <el-col :span="2" :offset="22">
                                <div>
                                    <v-tooltip top>
                                    <v-btn
                                            slot="activator"
                                            dark
                                            absolute
                                            right
                                            top
                                            fab
                                            color="orange"
                                            @click="addDetailProf"
                                    >

                                        <v-icon>add</v-icon>
                                    </v-btn>
                                        Ajouter une ligne
                                    </v-tooltip>
                                </div>
                            </el-col>
                        </el-row>
                    </el-form>

                </v-card-text>
                <v-card-actions class="text-xs-right mt-4">
                    <div style="width:100%" class="mt-4">
                        <v-btn
                                slot="activator"
                                dark
                                color="green"
                                @click="submitFormProf('formDynamiqueProf')"
                        >

                            Enregistrer

                            <v-icon dark right>save</v-icon>
                        </v-btn>
                    </div>
                </v-card-actions>
            </v-card>


        </v-dialog>


    </v-layout>
</template>

<script>
    import Loading from '@/components/Loading';
    export default {
        props:{
            idEmploye: {
                type: Number
            },
            show: {
                type: Boolean,
                default: false
            }
        },
        components: {Loading},
        name: "formDetailProf",
        data(){
            return{
                notif: JSON.parse(sessionStorage.getItem('sessionNotif')),
                domaine: JSON.parse(sessionStorage.getItem('sessionDomaine')),
                user: JSON.parse(sessionStorage.getItem('userInfo')),
                roleAcces: JSON.parse(sessionStorage.getItem('sessionAcces')),
                droitAcces: JSON.parse(sessionStorage.getItem('sessionDroit')),
                loading: false,

                dialogFormDetailProf: false,
                formDynamiqueProf:{
                    formDetailProfs:[
                        {
                            key:  1,
                            etablissement: null,
                            faculte: null,
                            periode: null,
                            dateDiplome: null,
                            diplome: null,
                            typeCont: null,
                            listePhotos:[],
                        }
                    ]
                },
                etablissement:'',
                faculte:'',
                diplome:'',
                dateDiplome:'',
                periode:'',
                
                listeTypeContrat:[
                    {
                        libelle:"Stagiaire formation",

                    },
                    {
                        libelle:"Stagiaire Professionnel",

                    },
                    {
                        libelle:"Temps partiel",

                    },
                    {
                        libelle:"Consultant",

                    },
                    {
                        libelle:"CDI",

                    },
                    {
                        libelle:"CDD",

                    },
                ],
                indiceForm: null


            }
        },
        watch:{
            show: function(newValue, oldValue){
                if(newValue == true){
                    this.loadTypeContrat();
                    this.dialogFormDetailProf = true
                }
                else{
                    this.dialogFormDetailProf = false
                }
            }
        },
        methods:{
            changeFile(file,fileList){
                console.log("indiceForm", this.indiceForm)
                console.log("file", file)
                console.log("fileListe", fileList)
                console.log("formulaire avant",this.formDynamiqueProf.formDetailProfs)
                console.log("formulaire indice 0",this.formDynamiqueProf.formDetailProfs[this.indiceForm])
                let formDyn =this.formDynamiqueProf.formDetailProfs[this.indiceForm]
                //formDyn.listePhotos = fileList
                console.log("formuDyn",formDyn)
                //console.log("index", ind)

                const fileReader = new FileReader()
                formDyn.listePhotos.splice(0)

                for (const ind in fileList){
                    let filename = fileList[ind].name;
                    if( filename.lastIndexOf(".") <= 0 ){
                        return alert("Veuillez selectionner un  format de fichier valide ")
                    }
                    formDyn.listePhotos.push(fileList[ind].raw);
                }
                console.log("formulaire apres",this.formDynamiqueProf)
            },
            successNotif(mess = ""){
                this.$notify({
                    title: 'ENREGISTREMENT REUSSI',
                    message: mess,
                    type: 'success',
                    position: 'top-center'
                })
            },

            addDetailProf() {
                this.formDynamiqueProf.formDetailProfs.push(
                    {
                        key: 44666,
                        etablissement: null,
                        faculte: null,
                        periode: null,
                        dateDiplome: null,
                        diplome: null,
                        typeCont: null,
                        listePhotos:[]
                    }
                );
            },

            removeProf(item) {
                var index = this.formDynamiqueProf.formDetailProfs.indexOf(item);
                if (index !== -1) {
                    this.formDynamiqueProf.formDetailProfs.splice(index, 1);
                }
            },
              //reinitialise le formulaire de creation de contrat
            resetFormDetails(){
                // this.formDynamiqueProf = {}
                this.formDynamiqueProf={
                    formDetailProfs:[
                        {
                            etablissement: null,
                            faculte: null,
                            periode: null,
                            dateDiplome: null,
                            diplome: null,
                            typeCont: null,
                            listePhotos:[],
                        }
                    ]
                }           
            },

            submitFormProf(formName){            
                this.formDynamiqueProf.formDetailProfs.forEach( (formDet,indx) =>{                    
                        this.etablissement = formDet.etablissement
                        this.periode = formDet.periode
                        this.faculte = formDet.faculte
                        this.dateDiplome = formDet.dateDiplome
                        this.diplome = formDet.diplome
                                                         
                    })
                        

                if(this.etablissement !=null && this.periode !=null){

                
                this.$refs[formName].validate((valid) => {
                     
                    if (!valid) {
                        return;
                    }                                      
                    this.loading = true;
                    let url = this.domaine + "rh/detailProfessionnel/" +this.idEmploye;
                    let data = new FormData();
                    data.append("listeDetailProf", JSON.stringify(this.formDynamiqueProf.formDetailProfs));
                    data.append("userCreated", this.user.id)

                    this.formDynamiqueProf.formDetailProfs.forEach( (formDet,indx) =>{
                        console.log("indx", indx)
                        let listesPhotos = formDet.listePhotos
                        listesPhotos.forEach(file => {
                            data.append("fichier"+indx+"[]", file, file[name]);
                        }, this);
                    })

                    this.$http.post(url,data).then(resp=>{
                        this.loading = false;
                        this.closeForm();
                        this.successNotif(resp.body.message)
                        this.resetFormDetails()
                    }, error=>{
                        this.loading = false;
                        this.$message.error("Echec lors de l'enregistrement des renseignements, Veuillez verifier votre connexion internet")
                    })

                });
                }else{
                    this.$message.error("veuillez renseigner tous les champs")
                }
            },

            loadTypeContrat(){
                let url = this.domaine + 'rh/listeTypeConge';
                this.$http.get(url).then(resData => {
                        this.listeTypeConge = resData.body.listeAbsences;
                        console.log("list conge",resData.body.listeAbsences )
                    },
                    error =>{
                        this.loading = false;
                        this.$message.error("Echec lors du chargement de al liste des type de conges, Veuillez verifier votre connexion internet")
                    })
            },

            resetForm(formName) {
                this.$refs[formName].resetFields();
            },
           

            closeForm(){
                this.$emit("close");
            }
        },

    }
</script>

<style scoped>
    /*.el-form-item__content {*/
        /*width: 70%;*/
    /*}*/
    .el-upload, .el-upload-dragger {
        width: 30% !important;
        height: 150px !important;
    }
</style>


// WEBPACK FOOTER //
// src/components/resourceHumaine/form_detail_prof.vue